<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="120">
      <FormItem label="角色编码：">{{editModel.userRoleCode}}</FormItem>
      <FormItem label="角色名称：">{{editModel.userRoleName}}</FormItem>
      <FormItem label="所属机构">{{editModel.organName}}</FormItem>
      <FormItem label="描述信息：">{{editModel.roleRemark}}</FormItem>
      <FormItem label="创建人：">{{editModel.createUser}}</FormItem>
      <FormItem label="创建时间：">{{$common.parseDate(editModel.createTime)}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  data: function () {
    return {
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>